<template>
  <div class="top-menu">
    <div class="content">
      <div class="top-bar">
        <div class="logo">
          <img src="@/assets/imgs/logo-shiyuan.png" alt="logo">
        </div>
<!--        <div class="actions">-->
<!--          <el-button class="btn-yellow" size="medium">注册</el-button>-->
<!--          <el-button class="btn-transparent" size="medium">登录</el-button>-->
<!--        </div>-->
      </div>
      <div class="nav">
        <router-link to="/home" class="nav-link" active-class="active">首页</router-link>
        <div class="dropdown">
          <a href="#" class="dropdown-toggle" :class="{ 'active': isProductServicePage }">产业服务</a>
          <div class="dropdown-menu">
            <router-link to="/analysis" class="dropdown-item">产业分析</router-link>
            <router-link to="/contact" class="dropdown-item">数字智囊</router-link>
            <router-link to="/dock" class="dropdown-item">资源市场</router-link>
          </div>
        </div>
        <router-link to="/digitize" class="nav-link" active-class="active">科技服务</router-link>
        <router-link to="/incubation" class="nav-link" active-class="active">孵化服务</router-link>
        <router-link to="/parlor" class="nav-link" active-class="active">产业会客厅</router-link>
        <router-link to="/policy" class="nav-link" active-class="active">产业政策</router-link>
        <router-link to="/news" class="nav-link" active-class="active">产业动态</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopMenu',
  computed: {
    isProductServicePage() {
      const productServiceRoutes = ['/analysis', '/contact', '/dock'];
      return productServiceRoutes.includes(this.$route.path);
    }
  }
}
</script>

<style scoped lang="scss">
.top-menu {
  width: 100%;
  color: #fff;
  position: absolute;
  top: 34px;
  left: 0;
  z-index: 1000;
  padding: 10px 0;
}

.content {
  width: 1200px;
  margin: 0 auto;
  height: 154px;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 41px;
}

.logo {
  display: flex;
  align-items: center;
  img {
    height: 40px;
    margin-right: 10px;
  }
  span {
    font-size: 24px;
    font-weight: bold;
  }
}

.nav {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  
  a, .nav-link {
    color: #fff;
    text-decoration: none;
    margin-right: 50px;
    font-size: 22px;
    position: relative;
    display: inline-block;
    padding: 0 20px 30px;
    white-space: nowrap;

    &:hover {
      color: #ffc107;
    }

    &.active {
      color: #ffc107;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -1px;
        width: 100%;
        height: 3px;
        background-color: #ffc107;
      }
    }
  }
  
  .dropdown {
    position: relative;
    
    &:hover .dropdown-menu {
      display: block;
    }
    
    .dropdown-toggle {
      color: #fff;
      text-decoration: none;
      margin-right: 50px;
      font-size: 22px;
      position: relative;
      display: inline-block;
      padding: 0 20px 30px;
      
      &:hover {
        color: #ffc107;
      }
    }
    
    .dropdown-menu {
      display: none;
      position: absolute;
      top: 100%;
      left: 0;
      margin-top: -1px;
      background-color: transparent;
      border-radius: 0;
      padding: 0;
      z-index: 1010;
      
      .dropdown-item {
        display: block;
        padding: 15px 20px;
        text-decoration: none;
        font-size: 18px;
        color: #fff;
        text-align: center;
        margin-right: 0;
        background-color: rgba(0, 0, 142, 0.6);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s ease;
        
        &:hover {
          background-color: #FFCC29;
          color: #00008E;
          font-weight: bold;
        }
      }
    }
  }
}

.actions {
  .btn-yellow {
    background-color: #ffc107;
    border-color: #ffc107;
    color: #000;
    width: 80px;
  }
  .btn-transparent {
    background-color: transparent;
    border: 1px solid #fff;
    color: #fff;
    width: 80px;
    &:hover {
      background-color: #fff;
      color: #000;
    }
  }
}
</style>